/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import router from 'umi/router';
import { stringify } from 'qs';
import { Button, Input, Select, Modal, message } from 'antd';
import FieldModal from '../FieldModal';
// eslint-disable-next-line import/extensions
import { downFile } from '@/services/postDownFileRequest';
import styles from './index.less';

const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal;

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '', // 搜索内容
      searchInfo: {
        type: '', // 部门类型
        deptSign: '', // 部门名称
      },
      visible: false,
      fieldModalVisible: false, // 显示字段modal状态
    };

    this.searchRef = React.createRef();
    this.downRef = React.createRef();

    this.handleDeleteBatchs = this.handleDeleteBatchs.bind(this);
    this.renderDeptType = this.renderDeptType.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleSetSelectedDeptVisible = this.handleSetSelectedDeptVisible.bind(this);
    this.handleBatchExport = this.handleBatchExport.bind(this);
    this.renderModalFooter = this.renderModalFooter.bind(this);
  }

  handleGotoSetting = () => {
    router.push(`/countyContacts/personnel/setting`);
  };

  handleGoToCreate = () => {
    const { userType } = this.props;
    router.push(
      `/countyContacts/personnel/edit?${stringify({ userType, modelType: 'create' })}`
    );
  };

  // 修改显示字段modal状态
  handelFieldChange = (status = true) => {
    this.setState({
      fieldModalVisible: status,
    });
  };

  handleDown = () => {
    const { exportUserUrl, userType, columnList } = this.props;
    const { searchInfo, searchValue } = this.state;
    const { deptSign, type } = searchInfo;

    const params = {
      deptId: deptSign,
      userType,
      deptType: type,
      searchField: searchValue,
      selectedAttributes: columnList
        .filter(({ sign }) => !!sign)
        .map(({ sign, name }) => ({
          sign,
          name,
        })),
    };

    downFile({ url: exportUserUrl, data: params, fileName: '人员管理列表.xlsx' }).then(() => {
      this.handleBatchExport({ status: false });
      message.success('导出成功');
    });
  };

  // 批量导入
  handleUpload() {
    const { handleUpload } = this.props;

    if (handleUpload) {
      handleUpload(true);
    }
  }

  // 批量删除
  handleDeleteBatchs() {
    const { selectedRowKeys, handleDeleteBatchs } = this.props;

    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.error('请至少选中一个人员');
      return null;
    }

    confirm({
      title: `确定要删除吗？`,
      content: '删除有风险，请仔细确认后执行删除操作',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        if (handleDeleteBatchs) {
          handleDeleteBatchs(selectedRowKeys);
        }
      },
    });
    return null;
  }

  // 修改选人组件状态
  handleSetSelectedDeptVisible() {
    const { selectedRowKeys, handleSetSelectedDeptVisible } = this.props;

    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      return message.error('请至少选中一个部门');
    }

    if (handleSetSelectedDeptVisible) {
      handleSetSelectedDeptVisible(true);
    }

    return true;
  }

  // 搜索
  handleSearch(val) {
    const { handleFetchList } = this.props;
    const { searchInfo } = this.state;
    const { type, deptSign } = searchInfo;

    this.setState(
      {
        searchValue: val,
      },
      () => {
        if (handleFetchList) {
          handleFetchList({
            searchParam: {
              deptType: type,
              deptId: deptSign,
              searchField: val,
            },
          });
        }
      }
    );
  }

  // 修改批量导出modal状态
  handleBatchExport({ status = false }) {
    this.setState({
      visible: status,
    });
  }

  // 渲染部门类型下拉框
  renderDeptType() {
    const { deptTypeList = [] } = this.props;
    const { searchInfo } = this.state;
    const { type } = searchInfo;

    return (
      <Select
        value={type}
        placeholder="全部部门类型"
        key="dept-type"
        onChange={val =>
          this.setState({
            searchInfo: { type: val, deptSign: '' },
          })
        }
      >
        {deptTypeList.map(({ typeName, typeSign }) => (
          <Option value={typeSign} key={typeSign}>
            {typeName}
          </Option>
        ))}
      </Select>
    );
  }

  renderModalFooter() {
    return (
      <div>
        <div ref={this.downRef} className="down-div" />
        <Button onClick={this.handleBatchExport}>取消</Button>
        <Button type="primary" onClick={this.handleDown}>
          确认
        </Button>
      </div>
    );
  }

  render() {
    const { userType, onFieldConfirm, columns } = this.props;
    const { visible, fieldModalVisible } = this.state;

    const modalProps = {
      title: '批量导出',
      visible,
      centered: true,
      onCancel: this.handleBatchExport,
      footer: this.renderModalFooter(),
    };

    return (
      <div className={styles.header}>
        <div className="btn-list">
          <Button type="primary" onClick={this.handleGoToCreate}>
            添加人员
          </Button>
          <Button onClick={this.handleUpload}>批量导入人员</Button>
          <Button onClick={() => this.handleBatchExport({ status: true })}>导出全部人员</Button>
          <Button onClick={this.handleSetSelectedDeptVisible}>批量加入部门</Button>
          <Button onClick={this.handleDeleteBatchs}>批量删除</Button>
          <Button onClick={this.handleGotoSetting}>设置字段</Button>
          <Button onClick={this.handelFieldChange}>显示字段</Button>
        </div>
        <div className="search-input">
          {/* {this.renderDeptType()}
          <TreeSelect
            treeDefaultExpandAll={false}
            style={{ width: '300px !important' }}
            defaultValue={deptSign}
            value={deptSign}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto', minHeight: 300 }}
            treeData={deptTreeList}
            onChange={val => this.setState({ searchInfo: { deptSign: val, type: '' } })}
          /> */}
          <Search
            placeholder={`请输入姓名、手机号码、所属${
              userType === 'teacher' ? '部门' : '班级'
            }搜索`}
            onSearch={this.handleSearch}
            ref={this.searchRef}
          />
        </div>
        <Modal {...modalProps}>
          <p>你确认要导出所有{userType === 'teacher' ? '教职工' : '学生'}成员吗？</p>
        </Modal>
        {!!fieldModalVisible && (
          <FieldModal
            onCancel={this.handelFieldChange}
            onConfirm={onFieldConfirm}
            columns={columns}
          />
        )}
      </div>
    );
  }
}
